import { Cart } from '@vsf-enterprise/sap-commerce-webservices-sdk';
import { NuxtCookies } from 'cookie-universal-nuxt';
import { ANONYMOUS_USER_ID, COOKIES_NAMES, CURRENT_USER_ID } from './constants';

function getActiveUserId(cookies: NuxtCookies): string {
  return cookies.get(COOKIES_NAMES.USER) ?? ANONYMOUS_USER_ID;
}

function getActiveCartId({
  cookies,
  currentCart
}: {
  cookies: NuxtCookies;
  currentCart?: Cart;
}): string {
  if (currentCart) {
    return getActiveUserId(cookies) !== CURRENT_USER_ID
      ? currentCart?.guid
      : currentCart?.code;
  }
  return cookies.get(COOKIES_NAMES.CART_ID);
}

export { getActiveUserId, getActiveCartId };
